import { EnquiryRequestService } from 'client/services';

const loader = async ({ request }) => {
    const url = new URL(request.url);
    const enquiries = await EnquiryRequestService.getEnquiriesRequest(url?.searchParams);

    return { enquiries };
};

export default loader;
